import { Box } from '@mui/material';
import React, { Suspense } from 'react';

import Header from '../../components/Header';

const LazyBarChart = React.lazy(() => import('../../components/BarChart'));

const Bar = () => {
  return (
    <Box m="20px">
      <Header title="Bar Chart" subtitle="Simple Bar Chart" />
      <Box height="75vh">
        <Suspense fallback={<div>Loading...</div>}>
          <LazyBarChart />
        </Suspense>
      </Box>
    </Box>
  );
};

export default Bar;
